<script setup lang="ts">
  import { computed } from 'vue';
  import { ShippingType } from '@othercommerce/domain';
  import { ShippingFurgonetkaMapWidget, ShippingPolkurierMapWidget } from '@storefront/components';

  interface Props {
    service: string,
    types: ShippingType[],
    pickupPointMap: { driver: 'FURGONETKA' | 'POLKURIER', mapKey: string | null, isSandbox: boolean },
  }

  const props = defineProps<Props>();

  const component = computed(() => {
    return props.pickupPointMap.driver === 'POLKURIER'
      ? ShippingPolkurierMapWidget
      : ShippingFurgonetkaMapWidget;
  });
</script>
<template>
  <component :is="component" :service :types :mapKey="pickupPointMap.mapKey" :isSandbox="pickupPointMap.isSandbox" />
</template>
